import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Input } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { Alert } from 'ui'
import { customSuccessNotification } from 'store/actions/notifications'
import Api from 'services/Api'
import { refreshCounter } from 'store/actions/refresh'
import { triggerResourcesRefresh } from 'store/actions/resources'

import { t } from 'translations'

const CreateClientModal = ({ name, setFieldValue, values }) => {
  const dispatch = useDispatch()

  // Form validation
  let clientShape = {
    name: Yup.string().required('administration.tags.form.NAME_REQUIRED'),
    importCode: Yup.string().importCode()
  }

  const onSubmit = async (tag, actions) => {
    // Set the tag icon
    tag.icon = 'fas fa-suitcase'
    tag.type = 'clients'
    // Saving the new tag
    const { message, success, tags } = await Api.post(`/tags/tags`, tag)
    if (!success) {
      actions.setSubmitting(false)
      actions.setStatus({ type: 'danger', msg: `employee.myProfile.${message}` })
    } else {
      triggerResourcesRefresh(dispatch, { resource: ['tags'] })
      dispatch(refreshCounter('tags'))
      customSuccessNotification(dispatch, { resourceType: 'TAG', isCreating: true })
      setFieldValue('clients', [...values, tags._id])
      !actions.isSubmitting && dispatch(closeModal())
    }
  }

  return (
    <BaseModal title="manager.projects.form.CREATE_CLIENT_MODAL" hideButtons>
      <Formik validationSchema={Yup.object().shape(clientShape)} enableReinitialize={true} initialValues={{ name, importCode: '' }} onSubmit={onSubmit}>
        {({ status, isSubmitting, dirty, resetForm, setStatus }) => {
          return (
            <Form resetForm={resetForm} dirty={!!dirty && !isSubmitting}>
              {() => (
                <>
                  {/* Error message */}
                  <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                    {status?.msg}
                  </Alert>

                  <Input module="administration.tags.form" name="name" required />
                  <Input
                    module="administration"
                    customDescription={t('administration.CODE.DESCRIPTION', { resources: t('administration.TAGS').toLowerCase() })}
                    name="importCode"
                  />

                  <div className="mt-4">
                    <Button className="btn btn-primary mr-2 " type="submit" isSubmitting={isSubmitting} text="employee.attendanceForm.SUBMIT" />
                    <Button className="btn btn-outline-secondary " onClick={() => dispatch(closeModal())}>
                      {t(`actions.CLOSE`)}
                    </Button>
                  </div>
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default CreateClientModal
